import React from 'react';
import { StyleSheet } from 'react-native';

import { LoadingSkeleton } from '@/components/SkeletonLoader';
import { Box } from '@/components/lib/components';
import { designSystem } from '@/styles/styles';

export const LobbyLeagueSkeleton = () => {
    return (
        <Box alignItems="center" justifyContent={'center'} paddingLeft="s16" paddingTop={'s16'}>
            <Box backgroundColor="gray6" style={styles.logo} width={44} height={44}>
                <LoadingSkeleton skeletonColor={designSystem.colors.gray3} width={44} height={44} style={styles.logo} />
            </Box>
            <LoadingSkeleton
                skeletonColor={designSystem.colors.gray3}
                width={44}
                height={20}
                borderRadius="r4"
                marginTop="s8"
            />
        </Box>
    );
};

const styles = StyleSheet.create({
    logo: {
        borderRadius: 13,
    },
});
